import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "label"],
  _excluded2 = ["type", "name", "label", "required", "component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Input, Modal, Form, Button, Checkbox, Select } from 'antd';
import styles from './prompt.module.scss';
class Prompt extends PureComponent {
  constructor() {
    super(...arguments);
    this.onCancel = () => {
      const {
        onClose
      } = this.props;
      onClose();
    };
    this.onFinish = values => {
      const {
        onClose,
        onSave
      } = this.props;
      onClose();
      onSave(values);
    };
    this.handleSubmit = e => {
      e.preventDefault();
      const {
        form
      } = this.props;
      form.validateFields((err, values) => {
        if (!err) {
          this.onFinish(values);
        }
      });
    };
    this.renderInput = _ref => {
      let {
          type,
          label
        } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded);
      switch (type) {
        case 'password':
          return /*#__PURE__*/React.createElement(Input.Password, null);
        case 'checkbox':
          return /*#__PURE__*/React.createElement(Checkbox, null, label);
        case 'select':
          return /*#__PURE__*/React.createElement(Select, {
            placeholder: label,
            allowClear: true
          }, rest.options.map(option => /*#__PURE__*/React.createElement(Select.Option, {
            key: option.value,
            value: option.value
          }, option.label)));
        default:
          return /*#__PURE__*/React.createElement(Input, null);
      }
    };
  }
  render() {
    const {
      title,
      fields,
      initialValues,
      form
    } = this.props;
    const {
      getFieldDecorator
    } = form;
    return /*#__PURE__*/React.createElement(Modal, {
      title: title,
      visible: true,
      closable: false,
      centered: true,
      footer: null
    }, /*#__PURE__*/React.createElement(Form, {
      layout: "vertical",
      className: styles.tapEditorPrompt,
      initialValues: initialValues,
      onSubmit: this.handleSubmit
    }, fields.map(_ref2 => {
      let {
          type,
          name,
          label,
          required,
          component
        } = _ref2,
        rest = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/React.createElement(Form.Item, _extends({
        name: name,
        label: label,
        required: required,
        key: name
      }, rest), getFieldDecorator(name, _objectSpread({}, rest))(component || this.renderInput(_objectSpread({
        type,
        label
      }, rest))));
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.tapEditorFooter
    }, /*#__PURE__*/React.createElement(Form.Item, null, /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      htmlType: "submit"
    }, __('Submit')), /*#__PURE__*/React.createElement(Button, {
      onClick: this.onCancel,
      className: styles.cancelButton
    }, __('Cancel'))))));
  }
}
Prompt.propTypes = {
  form: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string,
  fields: PropTypes.array,
  initialValues: PropTypes.object
};
Prompt.defaultProps = {
  title: '',
  fields: [],
  initialValues: {}
};
const WrappedPromptForm = Form.create({
  name: 'prompt'
})(Prompt);

/**
 * @description Show a modal with generated form fields based on the given options
 * @param {Object} options - Options to customize the prompt
 * @param {string} options.title - Title to be shown in the header of the prompt
 * @param {Object[]} options.fields - Array of fields to be shown in the prompt
 * @param {Object} options.initialValues - Initial value to be shown in field while opening the prompt
 * @callback options.callback - Call back on successful submission of the prompt
 */
export const openPrompt = _ref3 => {
  let {
    title,
    fields,
    initialValues,
    callback
  } = _ref3;
  const wrapperId = 'tap-editor-promptwrapper';
  let wrapper = document.getElementById(wrapperId);
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.setAttribute('id', wrapperId);
    document.body.appendChild(wrapper);
  }
  const onClose = () => {
    ReactDOM.unmountComponentAtNode(wrapper);
  };
  ReactDOM.render( /*#__PURE__*/React.createElement(WrappedPromptForm, {
    title: title,
    fields: fields,
    initialValues: initialValues,
    onSave: callback,
    onClose: onClose
  }), wrapper);
};